import EmployeeTable from "./EmployeeTable";

export default function PeriodRow({ period, isOpen, onToggle }) {
  return (
    <>
      <tr className="hover:bg-gray-50">
        <td
          className="px-3 py-2 font-semibold border"
          style={{ position: "sticky", left: 0, background: "#fff", zIndex: 10 }}
          onClick={onToggle}
        >
          {period.period_label}
        </td>

        <Td>{formatDate(period.period_end_date)}</Td>

        <Td center>
          <span className="badge bg-secondary">
            {period.employee_count}
          </span>
        </Td>

        <Money green>{period.total_gross_pay}</Money>
        <Money>{period.total_taxable_gross}</Money>
        <Money>{period.total_nic_able_gross}</Money>

        <Money red>{period.total_tax}</Money>
        <Money warn>{period.total_employee_nics}</Money>
        <Money info>{period.total_student_loan_deductions}</Money>

        <Money blue>{period.total_net_pay}</Money>
        <Money green>{period.total_take_home_pay}</Money>

        <Money>{period.total_employer_nics}</Money>
        <Money>{period.total_employer_pension}</Money>

        <Money info bold>{period.total_cost_to_employer}</Money>

        <Td center>
          <button
            className="btn btn-sm btn-outline-primary"
            onClick={onToggle}
          >
            {isOpen ? "🙈" : "👁"}
          </button>
        </Td>
      </tr>

      {isOpen && (
        <tr>
          <td colSpan={15} className="p-0">
             <div className="bg-gray-100 p-4 max-w-full overflow-x-auto">
        <div className="bg-white border rounded shadow-sm p-4 min-w-max">
          <h5 className="mb-4 font-semibold text-gray-700">
                  👥 Employee Breakdown – {period.period_label}
                </h5>

                <EmployeeTable entries={period.entries || []} />
              </div>
            </div>
          </td>
        </tr>
      )}
    </>
  );
}

/* =================== CELLS =================== */

const Td = ({ children, center }) => (
  <td
    className={`px-3 py-2 border ${
      center ? "text-center" : "text-left"
    }`}
  >
    {children}
  </td>
);

const Money = ({ children, green, red, warn, info, blue, bold }) => (
  <td
    className={`px-3 py-2 border text-right
      ${green ? "text-success" : ""}
      ${red ? "text-danger" : ""}
      ${warn ? "text-warning" : ""}
      ${info ? "text-info" : ""}
      ${blue ? "text-primary" : ""}
      ${bold ? "fw-semibold" : ""}`}
  >
    {formatMoney(children)}
  </td>
);

/* =================== HELPERS =================== */

const formatMoney = (v) =>
  v == null ? "–" : `£${Number(v).toFixed(2)}`;

const formatDate = (d) =>
  d ? new Date(d).toLocaleDateString("en-GB") : "-";
